import { createContext } from 'react'

/**
 * Whether an editor focuses its first field when it opens. Off where the editor follows the
 * highlighted filter, so moving through the filters keeps focus in their search.
 */
export const FilterEditorAutoFocus = createContext(true)
